import {
  LIST_ERP_VERSAO_QUERYS_INIT,
  LIST_ERP_VERSAO_QUERYS_SUCCESS,
  LIST_ALL_QUERYS_INIT,
  LIST_ALL_QUERYS_SUCCESS,
  CREATE_QUERY_INIT,
  CREATE_QUERY_SUCCESS,
  UPDATE_QUERY_INIT,
  UPDATE_QUERY_SUCCESS,
  DELETE_QUERY_INIT,
  DELETE_QUERY_SUCCESS,
  QUERYS_ERROR_MSG,
  CLEAR_FLAGS_QUERYS,
  CLEAR_QUERYS
} from '../actionTypes';
import { IQuery } from 'src/integracoes/servicos/mongo-atlas/modelos/IQuery';
import { IConsulta } from 'src/integracoes/servicos/mongo-atlas/modelos/IParametrosIntegracao';

const INIT_STATE = {
  querys: [] as (IConsulta & { source: string })[],
  allQuerys: [] as IQuery[],
  loading: false,
  loadingSave: false,
  isUpdated: false,
  isError: false,
  msg: ''
};

const querysReducer = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_ERP_VERSAO_QUERYS_INIT:
      return { ...state, loading: true, isError: false, msg: '' };
    case LIST_ERP_VERSAO_QUERYS_SUCCESS:
      return { ...state, querys: action.payload, loading: false };
    case LIST_ALL_QUERYS_INIT:
      return { ...state, loading: true, isError: false, msg: '' };
    case LIST_ALL_QUERYS_SUCCESS: {
      const { allQuerys } = action.payload;
      return { ...state, loading: false, allQuerys };
    }
    case CREATE_QUERY_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case CREATE_QUERY_SUCCESS: {
      const { query } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, allQuerys: [...state.allQuerys, query] };
    }
    case UPDATE_QUERY_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case UPDATE_QUERY_SUCCESS: {
      const { query } = action.payload;
      return {
        ...state,
        loadingSave: false,
        isUpdated: true,
        allQuerys: state.allQuerys.map((q) => (q.id === query.id ? query : q))
      };
    }
    case DELETE_QUERY_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case DELETE_QUERY_SUCCESS: {
      const { id } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, allQuerys: state.allQuerys.filter((q) => q.id !== id) };
    }
    case QUERYS_ERROR_MSG: {
      const msg = typeof action.payload === 'string' ? action.payload : action.payload?.msg;
      return { ...state, loading: false, loadingSave: false, isError: true, msg };
    }
    case CLEAR_FLAGS_QUERYS:
      return { ...state, isUpdated: false, isError: false, loadingSave: false, msg: '' };
    case CLEAR_QUERYS:
      return { ...state, querys: [], loading: false, isError: false, msg: '' };
    default:
      return { ...state };
  }
};

export default querysReducer;
